import {buyeeUrl} from "utils/url";

export function MainBanner({banner}) {
  return (
    <>
      {banner &&
        <div className="width-full tw-top__main-visual">
          <h1 className="width-max main-visual__bg">
            <span className="width-full">
              {(banner.pcImage && banner.spImage) ?
                <a href={banner.pcImage.linkUrl} target="_blank">
                  <img src={banner.pcImage.imageUrl} alt={banner.pcImage.alt} className="width-full display-none--s no-background-img"/>
                  <img src={banner.spImage.imageUrl} alt={banner.spImage.alt} className="width-full display-show--s no-background-img"/>
                </a>
                :
                <a href={buyeeUrl("signup/pre?lang=cht&rc=twy_cobrand_entry&twTran=1")} target="_blank">
                  <img src="https://cdn.buyee.jp/images/cobrand/pc/main_visual_no-campaign.png" alt="お得！Yahoo! JAPAN Auction Easy標" className="width-full display-none--s"/>
                  <img src="https://cdn.buyee.jp/images/cobrand/sp/main_visual_no-campaign.png" alt="お得！Yahoo! JAPAN Auction Easy標" className="width-full display-show--s"/>
                </a>
              }
            </span>
          </h1>
        </div>
      }
    </>
  );
}

export function BottomBanner({banner}) {
  return (
    <>
      {(banner.pcImage && banner.spImage) &&
        <div className="width-contents">
          <p className="campaign__banner">
            <a href={banner.pcImage.linkUrl} target="_blank">
              <img src={banner.pcImage.imageUrl} alt={banner.pcImage.alt} className="width-full display-none--s"/>
              <img src={banner.spImage.imageUrl} alt={banner.spImage.alt} className="width-full display-show--s"/>
            </a>
          </p>
        </div>
      }
    </>
  );
}

export function FollowBanner({banner}) {
  return (
    <>
      {(banner.pcImage && banner.spImage) &&
        <div className="width-full tw-coupon--follow">
          <div className="width-contents">
            <p className="tw-coupon__btn campaign-banner">
              <a href={banner.pcImage.linkUrl} target="_blank">
                <img src={banner.pcImage.imageUrl} alt={banner.pcImage.alt} className="width-full display-none--s"/>
                <img src={banner.spImage.imageUrl} alt={banner.spImage.alt} className="width-full display-show--s"/>
              </a>
            </p>
          </div>
        </div>
      }
    </>
  );
}
